import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const SelectSingleValue = (props) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <div className="flex items-center gap-2">
        {data.icon && <span className="text-gray-400">{data.icon}</span>}
        <span>{data.label}</span>
      </div>
    </components.SingleValue>
  );
};

SelectSingleValue.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SelectSingleValue;
